import { useRouter } from 'next/router';
import { VehicleEntry } from '@carvana/helios-composites';
import { datadogRum } from '@datadog/browser-rum';

import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { EventActions } from '../../analytics/uiMetrics';
import { APP_BASE_PATH } from '../../shared/appBasePath';
import { buildNavigationUrl } from '../../shared/routes';

const wizardRoute = `${APP_BASE_PATH}/getoffer/vehicle`;

type SubmitPlateVin = { vin: string } | { plate: string; plateState: string };
enum SubmissionType {
  Vin = 'Vin',
  PlateState = 'Plate/State'
}

const VehicleEntryContainer = () => {
  const router = useRouter();
  const { recordActionClicked, recordGenericEvent } = useAnalyticEvent();

  const handleSubmitEvent = (vin?: string) => {
    const payload = vin ? { vin } : undefined;
    const submissionType = vin ? SubmissionType.Vin : SubmissionType.PlateState;

    const genericEvent = recordGenericEvent(
      `LandingPage - ${submissionType} submission`,
      'Get My Offer',
      EventActions.Clicked,
      payload,
      true
    );
    const actionClickedEvent = recordActionClicked('Landing Page', 'Get My Offer', undefined, true);
    return Promise.all([genericEvent, actionClickedEvent]);
  };  
  
  const handleRedirect = async (redirectUrl: string, vin?: string) => {
    await handleSubmitEvent(vin);
    router.push(redirectUrl);
  };
  
  const submitPlateVin = (info: SubmitPlateVin) => {
    const sendToWizard: { vin: string } | { licensePlate: string; plateState: string } =
      'vin' in info ? { vin: info.vin } : { licensePlate: info.plate, plateState: info.plateState };
    
    if('vin' in info){
      datadogRum.setGlobalContextProperty('vin', info.vin);
    }
  
    const redirectUrl = buildNavigationUrl(wizardRoute, sendToWizard);
    handleRedirect(redirectUrl, 'vin' in info ? info.vin : undefined);
  };
  
  const queryParams = router?.query;

  return (
    <VehicleEntry
      submitPlateVin={submitPlateVin}
      submitText="Get My Offer"
      queryParams={queryParams}
    />
  );
};

export default VehicleEntryContainer;
